// ** api slice imports
import { slices } from '../../app/slice';

const routes = {
  GET_ALL_ANNOUNCEMENTS: '/announcements/all',
  GET_ALL_ACTIVE_ANNOUNCEMENTS: '/announcements',
  GET_ANNOUNCEMENTS_BY_CATEGORY: '/announcements/category/:category',
  GET_ANNOUNCEMENT_BY_ID: '/announcements/:id',
  CREATE_ANNOUNCEMENT: '/announcements',
  UPDATE_ANNOUNCEMENT: '/announcements/:id',
  DELETE_ANNOUNCEMENT: '/announcements/:id',
  RESTORE_ANNOUNCEMENT: '/announcements/:id/restore',
};

// ** slice for announcement
const announcementApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    getAllAnnouncements: builder.query({
      query: query => ({
        url: routes.GET_ALL_ANNOUNCEMENTS,
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getAllActiveAnnouncement: builder.query({
      query: query => ({
        url: routes.GET_ALL_ACTIVE_ANNOUNCEMENTS,
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getAnnouncementById: builder.query({
      query: id => ({
        url: routes.GET_ANNOUNCEMENT_BY_ID.replace(':id', id),
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getAnnouncementByCategory: builder.query({
      query: query => ({
        url: routes.GET_ANNOUNCEMENTS_BY_CATEGORY,
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    createAnnouncement: builder.mutation({
      query: data => ({
        url: routes.CREATE_ANNOUNCEMENT,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Announcements'],
    }),
    updateAnnouncement: builder.mutation({
      query: ({ id, data }) => ({
        url: routes.UPDATE_ANNOUNCEMENT.replace(':id', id),
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Announcements'],
    }),
    deleteAnnouncement: builder.mutation({
      query: ({ id }) => ({
        url: routes.DELETE_ANNOUNCEMENT.replace(':id', id),
        method: 'DELETE',
      }),
      invalidatesTags: ['Announcements'],
    }),
    restoreAnnouncement: builder.mutation({
      query: ({ id }) => ({
        url: routes.RESTORE_ANNOUNCEMENT.replace(':id', id),
        method: 'PATCH',
      }),
      invalidatesTags: ['Announcements'],
    }),
  }),
});

export const {
  useGetAllAnnouncementsQuery,
  useGetAllActiveAnnouncementQuery,
  useGetAnnouncementByIdQuery,
  useGetAnnouncementByCategoryQuery,
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useRestoreAnnouncementMutation,
} = announcementApiSlice;
